export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h16v16H0z" />
                <path
                    d="m9.226 8-4.195 4.233a.775.775 0 0 0-.231.567c0 .222.077.411.231.567a.761.761 0 0 0 .562.233c.22 0 .407-.078.561-.233l4.79-4.834c.352-.355.341-.722-.033-1.1l-4.757-4.8a.761.761 0 0 0-.561-.233.761.761 0 0 0-.562.233.775.775 0 0 0-.231.567c0 .222.077.411.231.567L9.226 8z"
                    fill="#2673FF"
                />
            </g>
        </svg>
    );
}
